import React, {useState, useEffect} from 'react'

import { Button } from 'reactstrap';
import { Modal, ModalDialog } from 'react-bootstrap';
import ShowMessages from '../../components/Exceptions'
import Draggable from 'react-draggable';
import loadingButton  from '../layouts/Buttons'
import api from '../../services/api';
import setStatistic from '../../services/apiStatistic'
import { ValidationForm } from 'react-bootstrap4-form-validation';
import { InstagramAuth } from './../../services/instagram';

class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}

export default function ModalMyNumberInstagram({showModal, handleCloseModal, data, handleReload,editState}) {
    const [idservice, setIDService]       = useState(0)
    const [appkey, setAppKey]             = useState('')
    const [description, setDescription]   = useState('')

    const setData = (obj,clear) => {
        console.log(obj)
        setAppKey(clear ? '' : obj.appkey)  
        setDescription(clear ? '' : obj.description) 
    }
      
    const handleSubmit = async(event) => {
        loadingButton(true,document.querySelector('#submit-el'),document.querySelector('#submit-el').children[0].classList,document.querySelector('#submit-el').lastChild.nodeValue)
        event.preventDefault()

        try {
            let _data = {idservice,
                         appkey,
                         description
                        }
              
            if (editState)
                await api.put('/el/' + data.idnumber, _data)
                         .then(response => {
                            ShowMessages(response)
                            if (response.ok) {
                                if (response.data.status === 200) {
                                    handleCloseModal()  
                                    handleReload(true)    
                                } else 
                                    loadingButton(false,document.querySelector('#submit-el'))
                            } else 
                                loadingButton(false,document.querySelector('#submit-el'))
                        })
                        .catch( error => {
                            loadingButton(false,document.querySelector('#submit-el'))
                            ShowMessages(error) 
                        })
            else
                await api.post('/el', _data)
                         .then(response => {
                            ShowMessages(response)
                            if (response.ok) {  
                                if (response.data.status === 200) {
                                    handleCloseModal()  
                                    handleReload(true)    
                                } else 
                                    loadingButton(false,document.querySelector('#submit-el'))        
                             } else 
                                loadingButton(false,document.querySelector('#submit-el')) 
                        })
                        .catch( error => {
                            loadingButton(false,document.querySelector('#submit-el'))
                            ShowMessages(error) 
                        })
        } catch (response) {
            loadingButton(false,document.querySelector('#submit-el'))
            ShowMessages(response)
        }
    }

    useEffect(() => {
        if (editState)
            setData(data,false)
        else 
            setData({},true)
    },[data,showModal])
   
    useEffect(() => {
        setStatistic('modals\\modal-mynumber-instagram')
    } ,[])

    return (
        <Modal size='md' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static" dialogClassName="width450" dialogAs={DraggableModalDialog}>
            <ValidationForm onSubmit={handleSubmit} setFocusOnError={true}>
                <Modal.Header closeButton>
                    <Modal.Title style={{marginBottom:"0px"}}>
                        <i className="fab fa-instagram"></i> Conexão com Instagram
                    </Modal.Title>
                </Modal.Header>
            
                <Modal.Body>
                    <div className='box-shadow' style={{display:"flex", justifyContent:"center"}}>
                        <InstagramAuth />
                    </div>
                </Modal.Body>
                <Modal.Footer> 
                    <Button type="submit" id="submit-el" className={`btn-theme`}>
                        <em className="fa fa-save"></em> Salvar
                    </Button> 
                    <Button type="button" className="btn-ligth-gray" onClick={e => handleCloseModal()}>
                        <em className="fa fa-door-closed"></em> Fechar
                    </Button>
                </Modal.Footer>
            </ValidationForm>
        </Modal>
    )
}